import lanscapeModeOverlayImg from "../assets/landscape/new_landscape_lock.png";

export function PortraitModeScreen({ enabledLandscape = false }) {
  return (
    <>
      <img
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: "fixed",
          zIndex: 9999,
        }}
        src={lanscapeModeOverlayImg}
        alt="landing screen"
      />
    </>
  );
}

export default PortraitModeScreen;
